<template>
    <az-call-to-action dark
                       :active="licitacao.podeAcessar"
                       :outline="!licitacao.podeAcessar"
                       :cssClass="botaoSolicitarDesabilitado ? 'botao-participar desabilitado' : 'botao-participar'"
                       @click="participarCredenciamento(licitacao)"
                       class="no-mobile">
        {{'Solicitar Credenciamento'}}
    </az-call-to-action>
</template>
<script>
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import {actionTypes} from "@/commons/constants";

export default {
  name: 'CredenciamentoFornecedorAcoesSolicitarCredenciamento',
  data() {
    return {
      pollingTimer: null
    }
  },
  computed: {
    ...mapState(['licitacao', 'credenciamento']),
    solicitacaoContemItens(){
      return this.credenciamento && this.credenciamento.solicitacaoContemItens
    },
    ehCredenciamentoAguardandoAbertura() {
      if (this.licitacao && this.licitacao.publicado) {
        const dataAbertura = moment(this.licitacao.dataAbertura)
        const dataAtual = moment(new Date())
        return dataAtual.isBefore(dataAbertura)
      }
      return false
    },
    botaoSolicitarDesabilitado() {
      return !(this.licitacao && this.licitacao.publicado)
    }
  },
  watch: {
    ehCredenciamentoAguardandoAbertura(novo) {
      if (novo) {
        this.iniciarPollingAbertura()
      } else {
        this.pararPollingAbertura()
      }
    }
  },
  mounted() {
    if (this.ehCredenciamentoAguardandoAbertura) {
      this.iniciarPollingAbertura()
    }
  },
  beforeDestroy() {
    this.pararPollingAbertura()
  },
  methods: {
    async participarCredenciamento() {
      if (this.botaoSolicitarDesabilitado) return

      if(!this.solicitacaoContemItens) {
        this.mostrarNotificacaoErro('É necessário salvar os itens selecionados ou selecionar ao menos um.')
        return
      }

      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Enviando solicitação de credenciamento...')
      try {
        await this.participarSolicitacaoCredenciamento(this.licitacao.id)
        await this.sincronizarProposta()
        this.mostrarNotificacaoSucessoDefault()
        this.$root.$emit('documentosReenviadosComSucesso');
      } catch (e) {
        this.desabilitarLoadingGlobal()
      }
    },
    async sincronizarProposta() {
      this.setMensagemLoading('Carregando dados da Proposta...')
      await this.buscarPropostaResumo(this.licitacao.id)
    },
    iniciarPollingAbertura() {
      if (this.pollingTimer) return
      this.pollingTimer = setInterval(async () => {
        if (!this.ehCredenciamentoAguardandoAbertura) {
          await this.buscarLicitacao(this.$route.params.id)
          clearInterval(this.pollingTimer)
          this.pollingTimer = null
        }
      }, 5000)
    },
    pararPollingAbertura() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    ...mapActions({
      participarSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.SOLICITACAO.PARTICIPAR_SOLICITACAO_CREDENCIAMENTO,
      buscarPropostaResumo: actionTypes.BUSCAR_PROPOSTA_RESUMO,
      buscarLicitacao: actionTypes.BUSCAR_LICITACAO
    })
  }
}
</script>
<style>
.botao-participar {
  padding: 10px !important;
}

.botao-participar.secondary {
  color: white !important;
  border: 1px solid white !important;
  border-radius: 3px !important;
  background-color: transparent !important;
}

.desabilitado {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
